import Http from '@/common/http'
export default class Auth {
  static index (param = {}) {
    return Http.post('/system/customer/index', param)
  }
  static doSubmit (param = {}) {
    return Http.post('/system/customer/doSubmit', param)
  }
  static getAuthorizerList (param = {}) {
    return Http.post('/system/authorizer/getAuthorizerList', param)
  }
  static getModuleList (param = {}) {
    return Http.post('/system/authorizer/getModuleList', param)
  }
  static doModuleSubmit (param = {}) {
    return Http.post('/system/authorizer/doModuleSubmit', param)
  }
  static getUrl (param = {}) {
    return Http.post('/system/authorizer/getUrl', param)
  }
  static getCustomerList (param = {}) {
    return Http.post('/system/authorizer/getCustomerList', param)
  }
  static doCustomerSubmit (param = {}) {
    return Http.post('/system/authorizer/doCustomerSubmit', param)
  }
  static userIndex (param = {}) {
    return Http.post('/system/user/index', param)
  }
  static userDoSubmit (param = {}) {
    return Http.post('/system/user/doSubmit', param)
  }
  static customer (param = {}) {
    return Http.post('/system/user/customer', param)
  }
  static authorizerCustomer (param = {}) {
    return Http.post('/system/authorizer/customer', param)
  }
  static userAuthorizer (param = {}) {
    return Http.post('/system/user/authorizer', param)
  }
  static setAuthorizer (param = {}) {
    return Http.post('/system/user/setAuthorizer', param)
  }
  static refreshMpUserInfo (param = {}) {
    return Http.get('/system/authorizer/refreshMpUserInfo', param)
  }
  static miniDoSubmit (param = {}) {
    return Http.post('/system/authorizer/doMiniSubmit', param)
  }
  static getUsetStatusList (param = {}) {
    return Http.get('/system/user/getUsetStatusList', param)
  }
  static auditUser (param = {}) {
    return Http.post('/system/user/auditUser', param)
  }
  static syncJdAccount (param = {}) {
    return Http.get('/system/user/syncJdAccount', param)
  }
  static getJdAccountList (param = {}) {
    return Http.get('/system/user/getJdAccountList', param)
  }
  static bindAccountByCustomer (param = {}) {
    return Http.post('/system/user/bindAccountByCustomer', param)
  }
  static getJdAuthorizerList (param = {}) {
    return Http.post('/system/user/getJdAuthorizerList', param)
  }
  static jdBindAppid (param = {}) {
    return Http.post('/system/user/jdBindAppid', param)
  }
  static getApiSecretStatusList (param = {}) {
    return Http.get('/system/authorizer/getApiSecretStatusList', param)
  }
  static getApiSecretList (param = {}) {
    return Http.get('/system/authorizer/getApiSecretList', param)
  }
  static updateApiSecretStatus (param = {}) {
    return Http.get('/system/authorizer/updateApiSecretStatus', param)
  }
  static saveApiSecret (param = {}) {
    return Http.get('/system/authorizer/saveApiSecret', param)
  }
  static clearFilterCache (param = {}) {
    return Http.get('/system/authorizer/clearFilterCache', param)
  }
  static saveAppInfo (param = {}) {
    return Http.post('/system/authorizer/saveAppInfo', param)
  }
}
